/**
 * Pronounce the dictionary lemma, not a parenthetical gloss.
 * "update (up to date)" → "update"
 * "automatized" → "automatized"
 */
export function extractPronounceLemma(raw) {
  if (raw == null) return '';
  const beforeParen = String(raw).split('(')[0];
  const token = beforeParen.trim().split(/\s+/)[0] || '';
  return token.replace(/^["'“”‘’.,;:!?()[\]{}]+|["'“”‘’.,;:!?()[\]{}]+$/g, '');
}

export function pronunciationCacheKey(raw) {
  return extractPronounceLemma(raw).toLowerCase();
}
